import { ReactNode } from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@/hooks/useAuth";
import { Loader2 } from "lucide-react";

export function ProtectedRoute({ children }: { children: ReactNode }) {
  const { session, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex flex-col items-center justify-center bg-background gap-6 relative overflow-hidden">
        <div className="absolute top-[-20%] left-[-10%] w-[60%] h-[60%] bg-primary/5 rounded-full blur-[120px]" />
        <div className="absolute bottom-[-20%] right-[-10%] w-[60%] h-[60%] bg-accent/5 rounded-full blur-[120px]" />
        <div className="relative z-10">
          <div className="w-20 h-20 rounded-[2.5rem] bg-gradient-to-br from-primary/10 to-primary/5 border border-primary/20 flex items-center justify-center animate-pulse shadow-2xl">
            <Loader2 className="w-10 h-10 animate-spin text-primary" />
          </div>
        </div>
        <div className="text-center space-y-2 relative z-10">
          <p className="text-lg font-extrabold text-foreground tracking-tight">Preparando ambiente</p>
          <p className="text-sm font-medium text-muted-foreground animate-pulse">Autenticando e carregando dados...</p>
        </div>
      </div>
    );
  }

  if (!session) {
    return <Navigate to="/auth" replace />;
  }

  return <>{children}</>;
}
